// Can the Admin reach its server? Every API call reports how it went: any answer (even an
// error status) means reachable; a failed connection means unreachable. The connection
// indicator reads this next to `navigator.onLine`, so "Connected" is only shown when the
// server really answers (UI0A-201). No imports: lib/api.ts reports here.

import { useSyncExternalStore } from 'react';

let reachable = true;
const listeners = new Set<() => void>();

/** Records the outcome of a request to the server. */
export function reportReachable(value: boolean): void {
  if (value === reachable) return;
  reachable = value;
  listeners.forEach((l) => l());
}

/** The last known reachability (true until a request fails to connect). */
export function isServerReachable(): boolean {
  return reachable;
}

export function onReachabilityChange(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

/** Re-renders when the server becomes reachable or unreachable. */
export function useServerReachable(): boolean {
  return useSyncExternalStore(onReachabilityChange, isServerReachable, isServerReachable);
}
